var React = require('react');

function CodeApl (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n"),React.createElement("polygon",{"points":"54.9,97.6 31.8,74.5 54.9,51.4 59.1,55.6 40.2,74.5 59.1,93.4 ","key":1}),React.createElement("polygon",{"points":"95.1,97.6 90.9,93.4 109.8,74.5 90.9,55.6 95.1,51.4 118.2,74.5 ","key":2}),React.createElement("rect",{"x":"42.7","y":"72","transform":"matrix(0.2829 -0.9592 0.9592 0.2829 -18.5112 125.2411)","width":"63.6","height":"6","key":3})]);
}

CodeApl.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 150 150","style":{"enableBackground":"new 0 0 150 150"},"xmlSpace":"preserve"};

module.exports = CodeApl;

CodeApl.default = CodeApl;
